import React, { useState, useCallback } from 'react';
import { compose, withProps } from 'recompose';
import JoinButton from '../common/JoinButton';
import FadeInContainer from '../common/FadeInContainer';
import { isJoinButtonAvailable } from '../heplers';
import Competitors from './CompetitorsTable';
import RaceRules from './RaceRules';
import DetailsFooter from './DetailsFooter';
import Games from './Games';
import withConditionalLayouts from './withConditionalLayouts';
import { withTranslations } from 'js/components/hocs/withTranslations';
import style from './index.scss';
import DetailsTabs from './DetailsTabs';
import RaceInfoTable from './RaceInfo/RaceInfoTable';
import Media from './Media';
import HeaderBanner from '../common/HeaderBanner';
import withSetNicknameOnce from '../Nickname/withSetNicknameOnce';

export const DetailsForMobile = (props) => {
    const {
        details,
        displayTable,
        displayGames
    } = props;
    const { name, rules, leaderboardRules } = details;
    const raceInfoClassName = [
        style.raceInfo,
        style.topBorder
    ].filter(Boolean).join(' ');

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const startTab = details.joined ? 0 : 1;
    const titleKey = props.useTournament ? 'competitorsTable.title.tournament' : 'competitorsTable.title';
    const tabs = [{ titleKey, name: 'leaderboard' }, { titleKey: 'rules.title', name: 'rules' }];
    const [activeTab, setActiveTab] = useState(tabs[startTab].name);
    const [isJoined, setIsJoined] = useState(details.joined);
    const onChangeTab = useCallback((tabName) => {
        setActiveTab(tabName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    if (isJoined !== details.joined) {
        setIsJoined(details.joined);
        const tab = details.joined ? 0 : 1;
        setActiveTab(tabs[tab].name);
    }

    if (props.details.status === 'ACTIVE' && props.details.joined) {
        if (props.details.eventCount) {
            if (props.details.eventCount < props.details.eventCountLimit) {
                props.details.fakeState = 'discoveryActive';
            } else {
                props.details.fakeState = 'discoveryCompleted';
            }
        } else {
            props.details.fakeState = 'discoveryActive';
        }
    } else if (props.details.status === 'ACTIVE' && !props.details.joined) {
        props.details.fakeState = 'discoveryAvailable';
    } else if (props.details.status === 'NOT_STARTED') {
        props.details.fakeState = 'discoveryUpcoming';
    } else if (props.details.status === 'PENDING_REVIEW' || props.details.status === 'COMPLETED') {
        props.details.fakeState = 'discoveryFinished';
    }

    return (
        <FadeInContainer className={style.container}>
            <div className={style.section}>
                <HeaderBanner {...details} text={name} useBackButton={props.showBackButton}
                              backButtonUrl={props.backButtonUrl} />
                <DetailsTabs tabs={tabs} activeTab={activeTab} onChange={onChangeTab} {...details} />
                <Media imageUrl={details.bannerUrl} visible={true} fakeState={props.details.fakeState} />
                {isJoinButtonAvailable(details) &&
                props.details.maxParticipantsCount !== props.details.participantsCount &&
                <JoinButton {...details} wide={true} {...props} />}
                {activeTab === tabs[0].name &&
                <Competitors className={style.competitors} displayTitle={false} displayTable={displayTable}
                             showPrizes={false} {...details} />}
                {activeTab === tabs[1].name && <RaceRules raceRules={rules} />}
                <div className={raceInfoClassName}>
                    <RaceInfoTable showIcon={false} {...details} />
                </div>
                {displayGames &&
                <>
                    <HeaderBanner {...details} translationKey={'gamesSection.title'} />
                    <Games rules={leaderboardRules} className={style.gamesContainer} />
                </>
                }
                <DetailsFooter wide={true} {...details} {...props} />
            </div>
        </FadeInContainer>
    );
};

export default compose(
    withConditionalLayouts,
    withTranslations,
    withProps(() => {
        const [joinAttempted, setJoinAttempted] = useState(false);
        return {
            displaySetNickname: joinAttempted,
            setJoinAttempted
        };
    }),
    withSetNicknameOnce
)(DetailsForMobile);
